module.exports = __webpack_public_path__ + "static/media/434111039_1539209350144799_8907626587304238552_n.727c14d8.jpg";